module.exports = __webpack_public_path__ + "img/in-car-display-integration.afdba630.png";